// https://github.com/bfred-it/supports-webp/blob/master/index.js
const canvas =
  typeof document === 'object' ? document.createElement('canvas') : ({} as HTMLCanvasElement);
canvas.width = 1;
canvas.height = 1;

export const webpSupported = canvas.toDataURL?.('image/webp')?.includes('image/webp') ? 1 : 0;
export const avifSupported = canvas.toDataURL?.('image/avif')?.includes('image/avif') ? 1 : 0;
